<template>
	<div class="long_row profile_builder">
		<div class="row">
			<div class="col-12 txt_container">
				<span>{{profileText}}</span>
			</div>
		</div>
		<div class="row">
			<div class="col-12 btn_container">
				<b-button class="btn" @click="showProfileQuestionModal">
					<span class="ic"></span>
					<span class="txt">Build Your Profile</span>
				</b-button>
			</div>
			<!--
			<div class="col-12 btn_container btn_center">
				<b-button class="btn btn_large" @click="showProfileQuestionModal">
					<span class="ic"></span>
					<span class="txt">Build Your Profile</span>
				</b-button>
			</div>
			-->
		</div>
    <learner-profile-question ref="profileBuilderQuestion"></learner-profile-question>
	</div>
</template>

<script>
  import { mapActions } from 'vuex'
  import LearnerProfileQuestion from './LearnerProfileQuestion'

	export default {
		name: 'learner-profile-builder',
    components: {
      LearnerProfileQuestion
    },
		data: () => {
			return {
        profileText: 'Tell us about yourself so that $TITLE$ can improve our recommendations'
			}
		},
    mounted () {
			this.loadInstitutionMetaInfo().then(resp => {
				this.profileText = this.profileText.replace('$TITLE$', resp.title)
			})
		},
    methods: {
			...mapActions([
	      'loadInstitutionMetaInfo'
	    ]),
      showProfileQuestionModal () {
        this.$refs.profileBuilderQuestion.showAddProgCarIntModal()
      }
		}
	}
</script>

<style scoped>
	.long_row {
    border-bottom: 1px solid #ebebeb;
    padding-top: 0;
    padding-bottom: 40px;
    margin-bottom: 40px;
  }

  .profile_builder {
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerProfileBuilder.vue